import axios from "axios";
import React, { Component } from "react";
import { Col, Row, NavLink } from "reactstrap";
import facebook from "../../assets/images/facebook-bg-min.png";
import linkedin from "../../assets/images/linkedin-bg-min.png";
import ChatApp from "../../pages/landing-2/chat-with-admin";
import twitter from "../../assets/images/twitter-bg-min.png";
import tiktok from "../../assets/images/tiktok-bg-min.png";
import instagram from "../../assets/images/instagram-bg-min.png";
import whatsapp from "../../assets/images/whatsapp-business-bg-min.png";
import constants from "../../Constants";
import NewsLetter from "../NewsLetter";
import FooterLinks from "./footer-links";
import AppDownloadLinks from "../common/AppDownloadLinks";

const baseURL = constants.baseURL;
const MEDIA = "https://media.qiktruck.co.za";

const FOOTER_TILES = [
  {
    href: "/bakkie-hire?src=footer",
    src: `${MEDIA}/footer-tile-bakkie.webp`,
    alt: "QikTruck bakkie on a South African driveway with furniture ready to load",
    title: "Bakkie hire",
    subtitle: "Local moves and furniture",
  },
  {
    href: "/movers-near-me?src=footer",
    src: `${MEDIA}/footer-tile-movers.webp`,
    alt: "QikTruck movers in hi-vis vests rolling a sofa on a furniture trolley",
    title: "Movers near you",
    subtitle: "House moves done right",
  },
  {
    href: "/truck-hire?src=footer",
    src: `${MEDIA}/footer-tile-truck.webp`,
    alt: "White QikTruck closed truck parked for a long-distance load",
    title: "Truck hire and long distance",
    subtitle: "Bigger loads, farther routes",
  },
  {
    href: "/regular-deliveries?src=footer",
    src: `${MEDIA}/footer-tile-business.webp`,
    alt: "QikTruck crew delivering parcels to a South African business entrance",
    title: "Regular business deliveries",
    subtitle: "Scheduled business freight",
  },
  {
    href: "/partner-drivers?dutq=footer",
    src: `${MEDIA}/footer-tile-driver.webp`,
    alt: "QikTruck partner driver in a branded hi-vis vest beside a white bakkie",
    title: "Drive with QikTruck",
    subtitle: "Register your vehicle",
  },
  {
    href: "/transportation-network",
    src: `${MEDIA}/footer-tile-ops.webp`,
    alt: "Operations team coordinating QikTruck deliveries on screens and tablets",
    title: "Software and operations",
    subtitle: "Network mastery",
  },
];

const FOOTER_LINK_GROUPS = [
  {
    id: "book",
    title: "Book",
    links: [
      {
        href: "/regular-deliveries?src=footer",
        label: "Book Regular Deliveries",
        highlight: true,
      },
      {
        href: "/furniture-delivery-services?src=footer",
        label: "Book Once off Delivery",
      },
      { href: "/bakkie-hire?src=footer", label: "Bakkie Hire" },
      { href: "/truck-hire?src=footer", label: "Truck Hire" },
      { href: "/movers-near-me?src=footer", label: "Movers Near Me" },
      {
        href: "/long-distance-moving?src=footer",
        label: "Long Distance Moving",
      },
      { href: "/routes?src=footer", label: "Transport Routes" },
    ],
  },
  {
    id: "drive",
    title: "Drive and grow",
    links: [
      { href: "/howitworks#howitworks", label: "How it Works" },
      { href: "/driver-guide", label: "Driver Guide" },
      { href: "/driver-packages", label: "Driver Boost" },
      {
        href: "/social",
        label: "Social Media Content Promotions",
      },
      {
        href: "/promoters",
        label: "Become a Promoter",
        highlight: true,
      },
      {
        href: "/partner-drivers?dutq=footer",
        label: "Vehicle Registration",
        highlight: true,
      },
      {
        href: "/vehicle-hire-price-survey?src=footer",
        label: "Vehicle Hire Price Survey",
      },
      { href: "/pricing", label: "Pricing/Fees" },
      { href: "/vacancies", label: "Jobs / Vacancies" },
      {
        href: "/in-service-training",
        label: "In-Service Training (WIL)",
      },
      {
        href: "/business-development",
        label: "Business Development Partners",
      },
    ],
  },
  {
    id: "business",
    title: "Business",
    links: [
      {
        href: "/regular-deliveries",
        label: "Business Solutions",
        highlight: true,
      },
      {
        href: "https://book.qiktruck.co.za/signup",
        label: "Business dashboard",
      },
      {
        href: "https://book.qiktruck.co.za/integrations",
        label: "Merchant integrations & widget",
      },
      {
        href: "https://book.qiktruck.co.za/api-docs?product=partner",
        label: "Partner API docs",
      },
      { href: "/developers", label: "Developer API" },
      {
        href: "/transportation-network",
        label: "Transportation Network",
      },
      { href: "/ads", label: "Vehicle Frame Advertising" },
      {
        href: "/realestate-partnerships",
        label: "Real Estate Partnerships",
      },
    ],
  },
  {
    id: "company",
    title: "Company",
    links: [
      { href: "/about#about", label: "About Us" },
      { href: "/investors", label: "Investor Relations" },
      { href: "/articles", label: "In The News" },
      { href: "/faqs", label: "Frequently Asked Questions" },
      { href: "/contact#contact", label: "Contact Us" },
      { href: "/terms", label: "Terms and Conditions" },
      { href: "/cancellation-policy", label: "Cancellation Policy" },
      { href: "/privacy", label: "Privacy Policy" },
    ],
  },
];

const SOCIAL_LINKS = [
  {
    href: "https://wa.me/+27663784460",
    src: whatsapp,
    alt: "WhatsApp",
  },
  {
    href: "https://twitter.com/QikTruckSA",
    src: twitter,
    alt: "X",
  },
  {
    href: "https://www.facebook.com/QikTruck",
    src: facebook,
    alt: "Facebook",
  },
  {
    href: "https://www.tiktok.com/@qiktruck.co.za",
    src: tiktok,
    alt: "TikTok",
  },
  {
    href: "https://www.instagram.com/qiktruck/",
    src: instagram,
    alt: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/qiktruck/",
    src: linkedin,
    alt: "LinkedIn",
  },
];

function FooterLinkItem({ href, label, highlight }) {
  return (
    <NavLink
      href={href}
      className={highlight ? "footer-action-button" : undefined}
    >
      <p>
        {highlight ? <span>{label}</span> : label} {">"}
      </p>
    </NavLink>
  );
}

class Footer extends Component {
  state = {
    stats: {
      q: "-",
      o: "-",
      v: "-",
      v2: "-",
    },
  };

  componentDidMount() {
    axios.get(baseURL + "/stats").then((repos) => {
      this.setState({ stats: repos.data });
    });
  }

  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="footer-container">
            <div className="get-a-quotation-now">
              <NavLink href="/quote#quotestart">
                Get a quotation in 30 seconds
              </NavLink>
            </div>

            <p className="usage-stats">
              {this.state.stats.v}{" "}
              <span> vehicles available on demand.</span>
              <br />
              {this.state.stats.v2}{" "}
              <span> vehicles available on quotations.</span>
            </p>

            <div className="footer-sections">
              {FOOTER_TILES.map((tile) => (
                <NavLink
                  key={tile.href + tile.title}
                  href={tile.href}
                  className="footer-tile"
                >
                  <figure className="footer-tile-figure">
                    <img
                      src={tile.src}
                      className="banner-image"
                      alt={tile.alt}
                      loading="lazy"
                    />
                    <figcaption className="footer-tile-caption">
                      <strong>{tile.title}</strong>
                      <span>{tile.subtitle}</span>
                    </figcaption>
                  </figure>
                </NavLink>
              ))}
            </div>

            <Row className="footer-link-groups">
              {FOOTER_LINK_GROUPS.map((group) => (
                <Col lg={3} md={6} sm={12} key={group.id}>
                  <div className="footer-link-group">
                    <h3 className="footer-list-title">{group.title}</h3>
                    {group.links.map((link) => (
                      <FooterLinkItem key={link.href + link.label} {...link} />
                    ))}
                    {group.id === "book" ? <AppDownloadLinks /> : null}
                    {group.id === "company" ? (
                      <div className="social-links">
                        {SOCIAL_LINKS.map((social) => (
                          <NavLink
                            key={social.href}
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-social-logo"
                          >
                            <img
                              src={social.src}
                              alt={social.alt}
                              className="footer-social-logo-img"
                              loading="lazy"
                            />
                          </NavLink>
                        ))}
                        <a
                          href="tel:+27663784460"
                          aria-label="Call QikTruck"
                          className="footer-call-link"
                        >
                          <i className="mdi mdi-phone"></i>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </Col>
              ))}
            </Row>

            <NewsLetter />
          </div>
        </footer>
        <FooterLinks />
        <ChatApp />
      </React.Fragment>
    );
  }
}

export default Footer;
